import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { SurveyQuery } from '~/QueryHooks/Survey'
import Layout from '~/components/Layout'
import { useDebounce } from 'use-lodash-debounce';
import i18n from '~/components/i18n'
import { RouteTypes } from '~/routes/constants'
import TableComponent from '~/components/TableComponent'
import { Input } from 'semantic-ui-react'
import { StyledDescription } from './style'

const getDefaultTableColumnHeaders = () => [
  {
    name: i18n.t('Farmer'),
    key: 'companyName',
    type: 'farmerLink'
  },
  {
    name: i18n.t('Status'),
    key: 'completed',
    type: 'surveyStatus'
  },
  {
    name: i18n.t('Reminder'),
    key: 'reminded',
    type: 'verified'
  },
  {
    name: i18n.t('Actions')
  }
];

const ResultsSurvey: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const [search, setSearch] = useState('')
  const debouncedSearchValue = useDebounce(search, 300)
  const [tableColumnHeaders, setTableColumnHeaders] = useState(getDefaultTableColumnHeaders())
  const [dataFiltered, setDataFiltered] = useState({
    page: 0,
    rows: 30,
    search: '',
    completed: ''
  })

  const actions = [
    {
      popupMessage: i18n.t('Show more'),
      type: 'link',
      name: 'eye',
      size: 'large',
      link: RouteTypes.SURVEY_SHOW_RESUTLS_ANSWERS.replace(':idSurvey', id),
      verifiedAction: 1,
      verifiedActionKey: 'completed'
    }
  ]

  const {
    isLoading: isBusyData,
    data: surveyFarmersList,
    refetch: fetchFilteredData,
    isFetching: isFetchingData
  } = SurveyQuery.getSurveysFarmers(
    id,
    {
      ...dataFiltered,
      page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
    }
  );

  const {
    data: surveyShowData,
    isLoading: isBusyShowData,
    refetch: fetchShowData
  } = SurveyQuery.showSurveyData(id)

  useEffect(() => {
    fetchFilteredData();
  }, [dataFiltered]);

  useEffect(() => {
    setDataFiltered({ ...dataFiltered, search: debouncedSearchValue, page: 0 });
  }, [debouncedSearchValue]);

  useEffect(() => {
    setTableColumnHeaders(getDefaultTableColumnHeaders())
    fetchShowData()
  }, [t])

  function renderTable() {
    return <TableComponent
      actions={actions}
      isFetchingData={isFetchingData}
      animated
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data, tableColumnHeaders) => {
        setTableColumnHeaders(tableColumnHeaders)
        setDataFiltered(data)
      }}
      rows={rows}
      total={filtered}
    />
  }

  function renderSearch() {
    return (
      <Input
        icon={{ name: 'search', circular: true, link: true }}
        placeholder={t('Search...')}
        value={search}
        onChange={(e, data) => setSearch(data.value)}
      />
    );
  }

  function renderDescription() {
    return <StyledDescription>
      {t('Description: {{description}}', { description: surveyShowData?.description })}
    </StyledDescription>
  }

  const { filtered, rows } = surveyFarmersList ? surveyFarmersList : { filtered: 0, rows: [] };

  return <Layout
    segmented
    close={RouteTypes.SURVEY}
    title={t('Survey: {{name}}', { name: surveyShowData?.title || '' })}
    isBusy={isBusyData || isBusyShowData}
    filters={renderSearch()}
  >
    {renderDescription()}
    {renderTable()}
  </Layout>
}
export default ResultsSurvey